import script from "./AdminDashbooard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashbooard.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashbooard.vue?vue&type=style&index=0&id=1d592df2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d592df2"]])

export default __exports__